import { Link } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

export default function PrivacyPolicyLink() {
  return (
    <Link to="#privacy-policy">
      <T>Privacy policy</T>
    </Link>
  );
}
